import Header from "../Header/Header";
import {Drawer} from "@material-ui/core";
import RightMenu from "../RightMenu";
import {GET} from "../Api/Rfm/RfmApi";
import React, {useEffect} from "react";
import {RfmRow} from "./RfmRow";
import {RfmHeader} from "./RfmHeader";
import {useCookies} from "react-cookie";
import Pagination from "react-js-pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

export const Rfm = () => {
    const [cookies, setCookie, removeCookie] = useCookies();
    const [state, setState] = React.useState({right: false});
    const [item, setItem] = React.useState(undefined);
    const [filter, setFilter] = React.useState([]);


    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({...state, [anchor]: open});
    };

    useEffect(() => {
        GET(cookies.user_server_token).then((res) => {
            setItem(res)
        });
    }, []);
    const FilterHandler=(e)=>{
        let key = e.target.attributes.type.value;
        let value = e.target.value;
        if (value === "") {
            // If the value is empty, remove the key from the filter object
            const updatedFilter = { ...filter };
            delete updatedFilter[key];
            setFilter(updatedFilter);
        } else
        setFilter((prevState) =>
            ({...prevState, [key]: value}));
         }

    useEffect(() => {
        GET(cookies.user_server_token, filter).then((res) => {
            setItem(res);
        });
    }, [filter]);
    return (
        <>
            {console.log(filter)}
            <Breadcrumb title={"  RFM  "} />


            <div className="container ltr mt-5 ">

                <table className="table table-striped">
                    <RfmHeader filter={FilterHandler}/>
                    {item && < RfmRow item={item.data}/>}
                </table>
                {item && (
                    <Pagination
                        totalItemsCount={item.total}
                        activePage={item.current_page}
                        itemsCountPerPage={item.per_page}
                        onChange={(number) => {
                            GET(cookies.user_server_token,filter,"",number).then((res) => {
                                setItem(res)
                            });
                        }}
                        itemClass="page-item"
                        linkClass="page-link"
                        firstPageText="اولین صفحه"
                        lastPageText="آخرین صفحه"
                        nextPageText="بعدی"
                        prevPageText="قبلی"
                        activeClass="pageactive"
                    />
                )}
            </div>
        </>
    )
}
